export const generateSecondaryFiltersSettings = (redemptionUnit, secondaryFilters) => {
  const isPoints = redemptionUnit === 'POINTS';

  return {
    ...secondaryFilters,
    budgetSettings: {
      ...secondaryFilters?.budgetSettings,
      currencyToDisplay: redemptionUnit,
      titleLabelKey: `cmp-budget-${isPoints ? 'pointer' : 'miles'}-title`,
      currencySelectorLabelKey: `cmp-budget-${isPoints ? 'pointer' : 'miles'}-cs-title`
    }
  };
};
